import styled from "styled-components";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.shades[0]};
  border-radius: ${({ theme }) => theme.radius}px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  display: grid;
  grid-template-columns: min-content 1px 1fr;
  height: 150px;
  .padding {
    padding: ${({ theme }) => theme.spacing * 4}px;
  }
  .divider {
    height: 150px;
    width: 1px;
    background-color: ${({ theme }) => theme.colors.gray[400]};
    align-self: center;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 2}px;
  .displayName {
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 16px;
    margin: 0;
    font-weight: 700;
  }
  .answers {
    color: ${({ theme }) => theme.colors.gray[400]};
    margin: 0;
    font-size: 14px
  }
  > button {
    padding: ${({ theme }) => theme.spacing * 2}px;
    align-self: end;
  }
`;
